import styled from 'styled-components';
export var PayPalButton = styled.button.withConfig({
  componentId: "sc-16hvra2-0"
})(["width:100%;height:100%;text-align:center;border-radius:4px;border:0;cursor:pointer;background-color:#ffc439;min-width:150px;max-width:750px;box-sizing:border-box;"]);
export var PayPalImage = styled.img.withConfig({
  componentId: "sc-16hvra2-1"
})(["height:25px;width:100px;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PayPal/styled.js
// module id = 4628
// module chunks = 11